export const isStringNumberOrBoolean = (value: unknown): value is string | number | boolean => {
  return ['string', 'number', 'boolean'].includes(typeof value);
};
